import { combineEpics } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { GlobalAppActions } from 'rdx/actions';
import { AppServices } from 'rdx/middleware';
import { GlobalAppState } from 'rdx/state';
import { ErrorReporter } from '@provider-portal/common/utils/errorReporting';

import {
  requestRequestResetPasswordAsyncAction,
  requestSetNewPasswordAsyncAction,
} from './actions';

const requestResetPasswordEpic = (
  action$: Observable<GlobalAppActions>,
  _state$: Observable<GlobalAppState>,
  { apiClient }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(requestRequestResetPasswordAsyncAction.request)),
    switchMap((action) => {
      return from(apiClient.deliveryProviderNoAuth.publicRequestResetPassword(action.payload)).pipe(
        switchMap((res) => {
          return of(requestRequestResetPasswordAsyncAction.success(res));
        }),
        catchError((e) => {
          ErrorReporter.captureException(e);
          return of(requestRequestResetPasswordAsyncAction.failure(e));
        }),
      );
    }),
  );
};

const resetPasswordEpic = (
  action$: Observable<GlobalAppActions>,
  _state$: Observable<GlobalAppState>,
  { apiClient }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(requestSetNewPasswordAsyncAction.request)),
    switchMap((action) => {
      return from(apiClient.deliveryProviderNoAuth.publicResetPassword(action.payload)).pipe(
        switchMap((res) => {
          return of(requestSetNewPasswordAsyncAction.success(res));
        }),
        catchError((e) => {
          ErrorReporter.captureException(e);
          return of(requestSetNewPasswordAsyncAction.failure(e));
        }),
      );
    }),
  );
};

export const passwordEpic = combineEpics(requestResetPasswordEpic, resetPasswordEpic);
